import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';

// Determine the current environment and set appropriate configuration
const getEnvironmentConfig = () => {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        
        // Local development
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return {
                userPoolId: 'us-east-1_kkqxT8kYS', // Beta User Pool for local dev
                userPoolClientId: '1gopnp6qbuiene0fcon4nt4mi5', // Beta Client for local dev
                apiEndpoint: 'https://1ghid62w5j.execute-api.us-east-1.amazonaws.com/beta/',
                region: 'us-east-1'
            };
        }
        
        // Beta environment
        if (hostname === 'beta.beadsbyjill.com') {
            return {
                userPoolId: 'us-east-1_kkqxT8kYS', // Beta User Pool
                userPoolClientId: '1gopnp6qbuiene0fcon4nt4mi5', // Beta Client
                apiEndpoint: 'https://1ghid62w5j.execute-api.us-east-1.amazonaws.com/beta/',
                region: 'us-east-1'
            };
        }
        
        // Production environment
        if (hostname == 'beadsbyjill.com' || hostname == 'www.beadsbyjill.com') {
            return {
                userPoolId: 'us-east-1_SazfFMPXa', // Prod User Pool
                userPoolClientId: '39a5qfqolu1ndd6hqv7fk1dt01', // Prod Client
                apiEndpoint: 'https://hv9t8x63rk.execute-api.us-east-1.amazonaws.com/prod/',
                region: 'us-east-1'
            };
        }
    }
    
    // Fallback for server-side rendering or unknown environments
    return {
        userPoolId: 'us-east-1_kkqxT8kYS',
        userPoolClientId: '1gopnp6qbuiene0fcon4nt4mi5',
        apiEndpoint: 'https://1ghid62w5j.execute-api.us-east-1.amazonaws.com/beta/',
        region: 'us-east-1'
    };
};

const envConfig = getEnvironmentConfig();

const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: envConfig.userPoolId,
            userPoolClientId: envConfig.userPoolClientId,
            region: envConfig.region,
        }
    },
    API: {
        REST: {
            AdminAPI: {
                endpoint: envConfig.apiEndpoint,
                region: envConfig.region,
                custom_header: async () => {
                    try {
                        const session = await fetchAuthSession();
                        return {
                            Authorization: `Bearer ${session.tokens?.idToken?.toString() || 'dummy-token'}`,
                        };
                    } catch (error) {
                        console.warn('Auth session not available:', error);
                        return {
                            Authorization: 'Bearer dummy-token',
                        };
                    }
                },
            },
        },
    },
};

export const configureAmplify = () => {
    try {
        console.log('Configuring AWS Amplify...');
        console.log('Environment config:', JSON.stringify(envConfig, null, 2));
        console.log('Amplify config:', JSON.stringify(amplifyConfig, null, 2));
        Amplify.configure(amplifyConfig);
        console.log('AWS Amplify configured successfully');
    } catch (error) {
        console.error('Error configuring AWS Amplify:', error);
        // Don't throw the error - let the app continue without Amplify
    }
};
